import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone } from 'lucide-react';
import { companyInfo } from '../mock';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-section)' }}>
      <div className="container text-center py-20">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-9xl font-bold mb-4" style={{ color: 'var(--accent-primary)' }}>404</h1>
          <h2 className="heading-2 mb-4">Page Not Found</h2>
          <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
            Looks like this page has been exterminated! Let's get you back on track.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary">
              <Home size={20} />
              Back to Home
            </Link>
            <a href={`tel:${companyInfo.phoneRaw}`} className="btn-secondary">
              <Phone size={20} />
              Call Us
            </a>
          </div>
          
          <div className="mt-12 pt-8 border-t" style={{ borderColor: 'var(--border-light)' }}>
            <h3 className="heading-3 mb-4">Looking for something specific?</h3>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/services" className="nav-link">Services</Link>
              <Link to="/areas" className="nav-link">Service Areas</Link>
              <Link to="/about" className="nav-link">About Us</Link>
              <Link to="/contact" className="nav-link">Contact</Link>
              <Link to="/blog" className="nav-link">Blog</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;